enum ApiTabQueryParam {
  Google = 'google',
  Omnichannel = 'omnichannel',
  Adswizz = 'adswizz',
  Dooh = 'dooh',
  Search = 'search',
  Social = 'social',
  Simplifi = 'simplifi',
  Gam = 'gam',
}

export default ApiTabQueryParam;
